import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';
import {CountryRestService} from '../../services/common/country-rest.service';
import {Membership} from '../../types/country/membership';

@Component({
  selector: 'wsd-select-membership',
  templateUrl: './select-membership.component.html',
  styleUrls: ['./select-membership.component.css']
})
export class SelectMembershipComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_MEMBERSHIP.LABEL';

  @Input()
  controlName: string = 'membershipType';

  @Input()
  showLabel: boolean = false;

  initialMembershipId: number;

  @Output()
  private onChange = new EventEmitter<void>();

  membershipItems: SelectItem[] = [];

  constructor(private countryService: CountryRestService) { }

  ngOnInit() {
    this.loadMemberships();
  }

  private loadMemberships() {
    this.countryService.getMembershops().subscribe(
      (memberships: Membership[]) => {
        this.fillMemberships(memberships);
        this.setInitialMembership();
      }
    );
  }

  private fillMemberships(memberships: Membership[]) {
    this.membershipItems = memberships.map(value => {
      return {
        label: value.translation,
        value
      };
    });
    this.membershipItems.unshift({label: '', value: null});
  }

  private setInitialMembership() {
    if (!this.initialMembershipId) {
      return;
    }
    for (const item of this.membershipItems) {
      if (item.value && item.value.id === this.initialMembershipId) {
        this.parentForm.get('membershipType').setValue(item.value);
        return;
      }
    }
  }

  change(event) {
    this.onChange.emit();
  }

}
